const isGCSUrl = (url) => {
  if (!!url) {
    const regExp = /^(?:https?:\/\/)?(?:www\.)?storage\.googleapis\.com/i;
    const match = new RegExp(regExp).test(url);
    if (match) {
      return true;
    }
  }
  return false;
};

export { isGCSUrl };
